import React, { Component } from 'react';
import { connect } from 'react-redux'


import fetchPassword from '../../../actions/fetchPassword'
import PasswordTable from './table/index'
import Modal from '../../../components/modal/index'
import Search from './searchInpur/Search'
import Spinner from '../../../components/spinner/Spinner'


class MainContent extends Component {

    componentDidMount() {
        this.props.fetchPassword(localStorage.getItem('uid'), this.props.match.params.vault)
    }
    componentDidUpdate(prevProps) {
        let self = this
        if (prevProps.match.params.vault !== this.props.match.params.vault) {
            self.props.fetchPassword(localStorage.getItem('uid'), this.props.match.params.vault)
        }
    }

    render() {
        let empty = (
            <div style={{ height: '500px' }} className="container d-flex justify-content-center align-items-center">
                <h5>
                    you dont have data yet, click add button to add new data
            </h5>
            </div>
        )
        return (<div className="container mt-5">
            <div className="row d-flex justify-content-between align-items-end">
                <h3>
                    <strong>
                        <span style={{ fontWeight: 'bolder' }}>
                            {this.props.match.params.vault}'s password
                       </span>
                    </strong>
                </h3>
                <div className='d-flex align-items-end'>
                    <div>
                        <Search data={this.props.search} />
                    </div>
                    <div>
                        <Modal actions='addNewPassword' vault={this.props.match.params.vault} modalTitle='New Password Data' btnColor='primary' btnTitle='add' btnSize='medium' />
                    </div>
                </div>
            </div>
            <hr />
            <div className="row">
                {
                    this.props.passwords.loading ? <Spinner margin='100px auto' size={50}/>
                        : this.props.passwords.passwords.length !== 0 ? <PasswordTable vault={this.props.match.params.vault} passwords={this.props.passwords.passwords} />
                            : this.props.passwords.passwords.length === 0 ? empty
                                : <h1>error while fetch data</h1>
                }
            </div>
        </div>);
    }
}

const mapStateToProps = (state) => {
    return (
        {
            passwords: state.passwordData,
            search: state.searchPassword.vaultsSearch
        }
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchPassword: (uid, vault) => dispatch(fetchPassword(uid, vault))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(MainContent);